import $ from "jquery";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { Link } from 'react-router-dom';
import React,{useState,useContext,useEffect} from 'react'
import { ManagerAuthConsultant } from "../context/AuhConsultant";
import axios from 'axios';

export const PanelConsultant = () => {

    const { currentUserCons } = useContext(ManagerAuthConsultant);

  const closeSide = () =>{
    $("#mobileMenuOpen").click(function () {
        $("#mobileMenu").addClass("open");
        $("#adjusmentLayer").addClass("show");
    });
}

const [showb, setShowb] = useState(false);
const handleCloseb = () => setShowb(false);
const handleShowb = () => setShowb(true);

const showPopup = () =>{
    handleShowb(true)
}

if (currentUserCons.tel === null) {
   } else {
  return (
    <>  
    <aside class="sidebar h-100 position-relative d-none d-md-block" dir='rtl'>
        <img src="../img/sidebar-auth-cover.png"
            class="position-absolute right-0 left-0 m-auto top-0 w-100 d-none d-xl-block" alt="" />
        <div class="auth-box-container m-auto d-none d-xl-block">
            <div class="auth-img-container">
                <img src="../img/Avatar-Image.png" alt="" class="avatar" />
            </div>
            <p class="text-center auth-name d-none d-xl-block">{currentUserCons.name}</p>
            <p class="text-center auth-role d-none d-xl-block">کاربر : مشاور</p>
            <p class="text-center auth-number d-none d-xl-block">{currentUserCons.meli}</p>
            <Link to="/Login"><button
                class="custom-btn-primary power-button m-auto position-relative overflow-hidden h-auto d-flex justify-content-center align-items-center">
               <i class="zmdi zmdi-power text-white"></i>
                <div class="reple position-absolute"></div>
            </button></Link>
        </div>
        <ul class="d-flex flex-column main-menu p-0">
            <img src="../img/Avatar-Image.png" alt="" width="58"
                class="d-block d-xl-none m-auto text-center mb-4 rounded-circle" />
            <li class="d-flex flex-column align-items-center justify-content-between w-100 color-primary">
                <Link to="/PanelConsultantRps/DasheboardCons" class="menu-active position-relative w-100 menu-item-container">
                    <div class="d-flex align-items-center justify-content-center">
                        <i class="zmdi zmdi-hc-fw text-primary"></i>
                        <p class="my-0 mx-3 d-none d-xl-block text-primary">داشبورد</p>
                    </div>
                </Link>
            </li>
            <li class="d-flex align-items-center justify-content-between w-100 color-primary">
                <Link to="" class="menu-active position-relative w-100 menu-item-container">
                    <div class="d-flex align-items-center justify-content-center">
                        <i class="zmdi zmdi-hc-fw"></i>
                        <p class="my-0 mx-3 d-none d-xl-block text-default">دستورات پزشکی</p>
                    </div>
                </Link>
            </li>
            <li class="d-flex align-items-center justify-content-between w-100 color-primary">
                <Link to="" class="menu-active position-relative w-100 menu-item-container">
                    <div class="d-flex align-items-center justify-content-center">
                        <i class="zmdi zmdi-hc-fw"></i>
                        <p class="my-0 mx-3 d-none d-xl-block text-default">کاردکس دارویی</p>
                    </div>
                </Link>
            </li>
            <li class="d-flex align-items-center justify-content-between w-100 color-primary">
                <Link to="" class="menu-active position-relative w-100 menu-item-container">
                    <div class="d-flex align-items-center justify-content-center">
                        <i class="zmdi zmdi-hc-fw"></i>
                        <p class="my-0 mx-3 d-none d-xl-block text-default">خلاصه پرونده</p>
                    </div>
                </Link>
            </li>
            <li class="d-flex align-items-center justify-content-between w-100 color-primary">
                <Link to="" class="menu-active position-relative w-100 menu-item-container">
                    <div class="d-flex align-items-center justify-content-center">
                        <i class="zmdi zmdi-hc-fw"></i>
                        <p class="my-0 mx-3 d-none d-xl-block text-default">شرح حال</p>
                    </div>
                </Link>
            </li>
            <li class="d-flex align-items-center justify-content-between w-100 color-primary">
                <Link to="" class="position-relative w-100 menu-item-container">
                    <div class="d-flex align-items-center justify-content-center">
                        <i class="zmdi zmdi-hc-fw text-default"></i>
                        <p class="my-0 mx-3 d-none d-xl-block text-default">سیر بیماری</p>
                    </div>
                </Link>
            </li>
            <li class="d-flex align-items-center justify-content-between w-100">
                <Link to="" class="position-relative w-100 menu-item-container">
                    <div class="d-flex align-items-center justify-content-center">
                        <i class="zmdi zmdi-hc-fw text-default"></i>
                        <p class="my-0 mx-3 text-default d-none d-xl-block">تیکت پشتیبانی</p>
                    </div>
                </Link>
            </li>
        </ul>
    </aside>
    <aside class="mobile-sidebar" id="mobileMenu" dir='rtl'>
        <ul class="d-flex flex-column main-menu-responsive p-0">
            <div class="d-flex flex-column justify-content-between align-items-center">
                <img src="../img/logo.png" width="140" alt="" />
            </div>
            <div class="devider"></div>
            <li class="d-flex align-items-center justify-content-between w-100 menu-item">
                <Link to="/PanelConsultantRps/DasheboardCons" class="position-relative w-100 menu-item-container">
                    <div class="d-flex align-items-center justify-content-center">
                        <i class="zmdi zmdi-home text-primary"></i>
                        <p class="my-0 mx-3 text-default text-primary">داشبورد</p>
                    </div>
                </Link>
            </li>
            <li class="d-flex align-items-center justify-content-between w-100 menu-item">
                <Link to="" class="position-relative w-100 menu-item-container">
                    <div class="d-flex align-items-center justify-content-center">
                        <i class="zmdi zmdi-hc-fw"></i>
                        <p class="my-0 mx-3 text-default">دستورات پزشکی</p>
                    </div>
                </Link>
            </li>
            <li class="d-flex align-items-center justify-content-between w-100 menu-item">
                <Link to="" class="position-relative w-100 menu-item-container">
                    <div class="d-flex align-items-center justify-content-center">
                        <i class="zmdi zmdi-hc-fw"></i>
                        <p class="my-0 mx-3 text-default">کاردکس دارویی</p>
                    </div>
                </Link>
            </li>
            <li class="d-flex align-items-center justify-content-between w-100 menu-item">
                <Link to="" class="position-relative w-100 menu-item-container">
                    <div class="d-flex align-items-center justify-content-center">
                        <i class="zmdi zmdi-hc-fw"></i>
                        <p class="my-0 mx-3 text-default">خلاصه پرونده</p>
                    </div>
                </Link>
            </li>
            <li class="d-flex align-items-center justify-content-between w-100 menu-item">
                <Link to="" class="position-relative w-100 menu-item-container">
                    <div class="d-flex align-items-center justify-content-center">
                        <i class="zmdi zmdi-hc-fw"></i>
                        <p class="my-0 mx-3 text-default">شرح حال</p>
                    </div>
                </Link>
            </li>
            <li class="d-flex align-items-center justify-content-between w-100 menu-item">
                <Link to="" class="position-relative w-100 menu-item-container">
                    <div class="d-flex align-items-center justify-content-center">
                        <i class="zmdi zmdi-hc-fw text-default"></i>
                        <p class="my-0 mx-3 text-default">سیر بیماری</p>
                    </div>
                </Link>
            </li>
            <li class="d-flex align-items-center justify-content-between w-100 menu-item">
                <Link to="" class="position-relative w-100 menu-item-container">
                    <div class="d-flex align-items-center justify-content-center">
                        <i class="zmdi zmdi-hc-fw text-default"></i>
                        <p class="my-0 mx-3 text-default">تیکت پشتیبانی</p>
                    </div>
                </Link>
            </li>
        </ul>
    </aside>
    
    <div class="d-flex flex-column w-100" dir='rtl'>
      
        <div class="block-header d-flex d-md-none flex-row-reverse">
            <div class="d-flex justify-content-center align-items-center flex-row-reverse">
                <img src="../img/Avatar-Image.png" class="block-header-auth-img rounded-circle" alt="" />
                <button class="btn btn-icon mobile_menu mx-3" type="button"> <i
                        class="zmdi zmdi-settings mx-3"></i></button>
                <button class="btn btn-icon mobile_menu" type="button"> <i class="zmdi zmdi-power"></i></button>
            </div>
            <button class="btn btn-icon mobile_menu custom-bg-primary" type="button" onClick={closeSide} id="mobileMenuOpen"><i
                    class="zmdi zmdi-sort-amount-desc"></i></button>
        </div>
        <div class="d-none d-md-flex w-100">
            <div class="app-header-bar p-24 w-100">
                <div class="d-flex align-items-center justify-content-between">
                    <div class="w-50 d-flex justify-content-start align-items-center w-auto">
                        <button
                            class="custom-btn-primary ml-16 app-header-botton-control position-relative w-auto px-1">
                            <span> دریافت
                                گزارش
                                کاربری</span>
                            <span class="app-header-botton-devider mx-2"></span>
                            <div href="#" class="app-header-botton-control-link">
                                <img src="../icons/exists icon arrow.svg" alt="" />
                            </div>
                        </button>
                        <div class="form-group position-relative">
                            <img src="../icons/Search.svg" class="position-absolute input-icon" alt="" />
                            <input type="text" class="form-control app-header-search-container"
                                placeholder="دنبال چی هستی؟" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <Modal show={showb} onHide={handleCloseb} className=''>
        <Modal.Body>
        <div id="Removemodal" tabindex="-1" role="dialog"
                                    aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                                    <div class="modal-dialog modal-dialog-centered" role="document">
                                        <div class="modal-content">
                                            <div class="modal-header text-center border-0 p-0">
                                                <img src="../img/remove.png" class="m-auto" alt="" />
                                            </div>
                                            <div class="modal-body text-center border-0 p-0 border-end-0">
                                                <h3>مطمعنی میخوای حذف کنی</h3>
                                                <p class="t-16">شما درحال حذف کاربر میلاد اعرابها هستید . آیا حذف انجام
                                                    شود؟</p>
                                            </div>
                   
                                        </div>
                                    </div>
          </div>
        </Modal.Body>

        <div class="modal-footer flex-row-reverse border-0 w-100 justify-content-center p-0" dir='rtl'>
                <button type="button" class="btn custom-btn-secondary d-inline-block"
                   data-dismiss="modal">لغو</button>
                    <button type="button" class="btn custom-btn-danger d-inline-block">بله
                     حذف کن</button>
                  </div>

      </Modal>

    </>
  )
}
}
